import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import TaskJobDetails from './TaskJobDetails';
import authService from './api-authorization/AuthorizeService';

interface JobComplete {
    id: number;
    jobDetails: JobDetails;
    completeId: number;
    loading: boolean;
    errors: any;
    cancelReasonId: number;
    cancelReasons: GenericList[];
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    siteAddress: string;
    lotNumber: string;
    items: ItemList[];
}

interface ItemList {
    id: number;
    item: string;
    itemId: number;
    status: string;
    hirePeriodDays: string;
    quantityMeasure: string;
    amountFormatted: string;
    overhireRateFormatted: string;
}

interface INameToValueMap {
    [key: string]: any;
}

interface GenericList {
    id: number;
    name: string;
}

export class TaskCheckJobCompleteData extends React.Component<RouteComponentProps<{}>, JobComplete> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: 0,
            jobDetails: {
                jobId: 0,
                customer: "",
                customerContact: "",
                mobile: "",
                phone: "",
                siteAddress: "",
                lotNumber: "",
                items: []
            },
            completeId: -1,
            cancelReasonId: -1,
            cancelReasons: [],
            loading: true,
            errors: {}
        };
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        this.setState({ id: Id });

        axios.get('api/User/CheckUserPermission?Permission=RunCheckJobCompleteTask&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //get the list of cancel reasons for any existing jobs 
                axios.get('api/Job/GetCancelReasons?SubId=' + user.sub, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    this.setState({ cancelReasons: res.data })

                    //assign task to current user
                    var taskdetails = {
                        Id: Id,
                        SubId: user.sub
                    };
                    axios.post('api/Tasks/AssignTask', taskdetails, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                    .then(res => {
                        //this needs to just happen in the background
                    });

                    axios.get('api/Tasks/GetTaskCheckJobCompleteDetails?Id=' + Id, {
                        headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                    })
                    .then(res => {
                        this.setState({ id: Id, jobDetails: res.data, loading: false });
                    })
                    .catch(error => {
                        toast.error(error.message);
                    });
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    validate = () => {
        let formIsValid = true;
        let errors: any = {};

        if (this.state.completeId < 1) {
            formIsValid = false;
            errors["completeId"] = "Is the job complete is required";
        } else if (this.state.completeId == 4 && this.state.cancelReasonId < 1) {
            formIsValid = false;
            errors["cancelReasonId"] = "Cancel Reason is required";
        };

        this.setState({ errors: errors });
        return formIsValid;
    }

    contactSubmit = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.submit();
        } else {
            //alert("Form has errors.")
        }

    }

    submit = () => {
        this.save();
    }

    async save() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var details = {
            taskId: this.state.id,
            jobId: this.state.jobDetails.jobId,
            completeId: this.state.completeId,
            cancelReasonId: this.state.cancelReasonId,
            subId: user.sub
        };

        axios.post('api/Tasks/SaveCheckJobComplete', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Task Saved");
            if (this.state.completeId == 3) {
                this.props.history.push("/schedule")
            } else {
                this.props.history.push("/tasks")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Check Job Complete</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var jobDetails = this.state.jobDetails;
        var phone = jobDetails.mobile != "" && jobDetails.phone != "" ? jobDetails.mobile + " or " + jobDetails.phone : jobDetails.mobile != "" ? jobDetails.mobile : jobDetails.phone;
        let cancelReasonOptions = this.state.cancelReasons;
        let taskJobDetails = <TaskJobDetails jobDetails={jobDetails} />

        return (
            <form name="jobDetails" onSubmit={this.contactSubmit}>
                <div>
                    <span>Please call {jobDetails.customerContact} from {jobDetails.customer} on {phone} to see if any more items are going ahead or if the job is complete:</span>
                    {taskJobDetails}
                    <div>
                        <div className="table__margin overflowAuto">
                            <table className="table table__large tableColours">
                                <thead>
                                    <tr>
                                        <th className="hidden">Id</th>
                                        <th>Item</th>
                                        <th>Status</th>
                                        <th>Hire Period</th>
                                        <th>Quantity</th>
                                        <th>Amount</th>
                                        <th>Overhire Rate</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {jobDetails.items.map((item, index) =>
                                        <tr key={index}>
                                            <td className="hidden">{item.id}</td>
                                            <td className="table__text--align">{item.item}</td>
                                            <td className="table__text--align">{item.status}</td>
                                            <td className="table__text--align">{item.hirePeriodDays}</td>
                                            <td className="table__text--align">{item.quantityMeasure}</td>
                                            <td className="table__text--align">{item.amountFormatted}</td>
                                            <td className="table__text--align">{item.overhireRateFormatted}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <label className="input-group" htmlFor="completeId">
                            <span className="label">Is the job complete?</span>
                            <select className="select" id="completeId" name="completeId" value={this.state.completeId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                <option value="1">Yes - Complete</option>
                                <option value="2">No - Pending</option>
                                <option value="3">No - Items Ready to Schedule</option>
                                <option value="4">No - Cancel Job</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["completeId"]}</span>
                    </div>
                    <div className={this.state.completeId == 4 ? "" : "hidden"}>
                        <label className="input-group" htmlFor="cancelReasonId">
                            <span className="label">Cancel Reason</span>
                            <select className="select" id="cancelReasonId" name="cancelReasonId" value={this.state.cancelReasonId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                {cancelReasonOptions.map(reason =>
                                    <option key={reason.id} value={reason.id}>{reason.name}</option>
                                )};
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["cancelReasonId"]}</span>
                    </div>
                    <br></br>
                    <div className="row">
                        <button className="defaultbutton-prev" type="submit">Save</button>
                    </div>
                </div>
            </form>
        );
    }
}
